import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-row items-center gap-3 sm:gap-4 lg:gap-6 py-4 sm:py-6">
            <img
              src="https://acsfutureschool.com/afs.png"
              alt="AFS Logo"
              className="h-10 w-10 sm:h-12 sm:w-12 object-contain flex-shrink-0"
            />
            <div className="min-w-0 flex-1">
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 break-words">
                AFS Teachers Dashboard
              </h1>
              <span className="text-sm sm:text-base text-gray-600 block mt-1">
                Powered by{' '}
                <a
                  href="https://abusayem.me"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  Md. Abu Sayem
                </a>
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* Main */}
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-4xl -translate-y-6 sm:-translate-y-10">
          <div className="text-center mb-6 sm:mb-7">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-2">
              Select a Content
            </h2>
            <p className="text-gray-500 text-sm sm:text-base">
              Choose which content you'd like to view
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* AFS Live Class Schedule */}
            <button
              onClick={() => navigate('/live-class')}
              className="group flex flex-col items-center justify-center gap-4 bg-white border-2 border-gray-200 rounded-2xl p-8 shadow-sm hover:border-blue-500 hover:shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 min-h-[180px]"
            >
              <div className="w-14 h-14 rounded-full bg-blue-50 group-hover:bg-blue-100 flex items-center justify-center transition-colors duration-200">
                <svg
                  className="w-7 h-7 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div className="text-center">
                <span className="block text-base sm:text-lg font-semibold text-gray-800 group-hover:text-blue-700 transition-colors duration-200">
                  AFS Live Class Schedule
                </span>
                <span className="block text-sm text-gray-500 mt-1">
                  View the live class timetable
                </span>
              </div>
            </button>

            {/* AFS Promotional Content Schedule */}
            <button
              onClick={() => navigate('/promo-schedule')}
              className="group flex flex-col items-center justify-center gap-4 bg-white border-2 border-gray-200 rounded-2xl p-8 shadow-sm hover:border-purple-500 hover:shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 min-h-[180px]"
            >
              <div className="w-14 h-14 rounded-full bg-purple-50 group-hover:bg-purple-100 flex items-center justify-center transition-colors duration-200">
                <svg
                  className="w-7 h-7 text-purple-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div className="text-center">
                <span className="block text-base sm:text-lg font-semibold text-gray-800 group-hover:text-purple-700 transition-colors duration-200">
                  AFS Promotional Content Schedule
                </span>
                <span className="block text-sm text-gray-500 mt-1">
                  View the promotional content plan
                </span>
              </div>
            </button>

            {/* Live Class Feedback */}
            <button
              onClick={() => navigate('/feedback')}
              className="group flex flex-col items-center justify-center gap-4 bg-white border-2 border-gray-200 rounded-2xl p-8 shadow-sm hover:border-amber-500 hover:shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 min-h-[180px]"
            >
              <div className="w-14 h-14 rounded-full bg-amber-50 group-hover:bg-amber-100 flex items-center justify-center transition-colors duration-200">
                <svg
                  className="w-7 h-7 text-amber-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                  />
                </svg>
              </div>
              <div className="text-center">
                <span className="block text-base sm:text-lg font-semibold text-gray-800 group-hover:text-amber-700 transition-colors duration-200">
                  Live Class Feedback
                </span>
                <span className="block text-sm text-gray-500 mt-1">
                  Teacher ratings from student feedback
                </span>
              </div>
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
